import { HttpContextToken } from '@angular/common/http';

export const SKIP_TRANSFER_STATE = new HttpContextToken<boolean>(() => false);
